// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.panel{
    display: none;
    animation: fadeIn 1s both;
    
}
.showpanel{
    display: grid;
    animation: fadeIn 1s both;

}
.listchange{
    border: none;
    font-size: 15px;
    background-color: transparent;
    color: white;
    display: inline-block;
}
.outeracord{
    padding: 0;
    border: none;
    background-color: #f3eeea ;
    font-size: large;
    padding-left: 8px;
}
/* Make form container full width on small screens */
@media (max-width: 768px) {
  .login-form-container {
    width: 100% ;
    padding: 0 15px;
  }

  .card {
    width: 100% !important;
    padding: 10px !important;
  }

  .form-header {
    font-size: 16px !important;
    text-align: center;
  }

  .footer-container {
    flex-direction: column !important;
    text-align: center;
    padding: 15px 10px !important;
  }

  .footer-logo-container {
    justify-content: center !important;
    margin-top: 10px;
  }

  .footer-logo-container img {
    width: 80px;
  }

  .form-control {
    font-size: 14px !important;
  }
}

/* Better layout for mid-sized devices */
@media (min-width: 769px) and (max-width: 1024px) {
  .login-form-container {
    width: 90% !important;
  }

  .card {
    width: 100% !important;
  }

  .footer-container {
    padding: 15px 25px !important;
  }
}

.pdf-table {
  width: 100%;
  border-collapse: separate;
  border-spacing: 0;
  table-layout: fixed;
}

.pdf-table th,
.pdf-table td {
  padding: 6px;
  font-size: 12px;
  box-shadow:
    inset -1px 0 0 #000,   /* RIGHT */
    inset 0 -1px 0 #000;  /* BOTTOM */
}

/* LEFT border */
.pdf-table th:first-child,
.pdf-table td:first-child {
  box-shadow:
    inset 1px 0 0 #000,
    inset -1px 0 0 #000,
    inset 0 -1px 0 #000;
}

/* TOP border */
.pdf-table tr:first-child th {
  box-shadow:
    inset 0 1px 0 #000,
    /* inset -1px 0 0 #000, */
    inset 0 -1px 0 #000;
}
`, "",{"version":3,"sources":["webpack://./src/Components/admin/admin.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,yBAAyB;;AAE7B;AACA;IACI,aAAa;IACb,yBAAyB;;AAE7B;AACA;IACI,YAAY;IACZ,eAAe;IACf,6BAA6B;IAC7B,YAAY;IACZ,qBAAqB;AACzB;AACA;IACI,UAAU;IACV,YAAY;IACZ,0BAA0B;IAC1B,gBAAgB;IAChB,iBAAiB;AACrB;AACA,oDAAoD;AACpD;EACE;IACE,YAAY;IACZ,eAAe;EACjB;;EAEA;IACE,sBAAsB;IACtB,wBAAwB;EAC1B;;EAEA;IACE,0BAA0B;IAC1B,kBAAkB;EACpB;;EAEA;IACE,iCAAiC;IACjC,kBAAkB;IAClB,6BAA6B;EAC/B;;EAEA;IACE,kCAAkC;IAClC,gBAAgB;EAClB;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,0BAA0B;EAC5B;AACF;;AAEA,wCAAwC;AACxC;EACE;IACE,qBAAqB;EACvB;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,6BAA6B;EAC/B;AACF;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;;EAEE,YAAY;EACZ,eAAe;EACf;;uBAEqB,GAAG,WAAW;AACrC;;AAEA,gBAAgB;AAChB;;EAEE;;;uBAGqB;AACvB;;AAEA,eAAe;AACf;EACE;;;uBAGqB;AACvB","sourcesContent":[".panel{\n    display: none;\n    animation: fadeIn 1s both;\n    \n}\n.showpanel{\n    display: grid;\n    animation: fadeIn 1s both;\n\n}\n.listchange{\n    border: none;\n    font-size: 15px;\n    background-color: transparent;\n    color: white;\n    display: inline-block;\n}\n.outeracord{\n    padding: 0;\n    border: none;\n    background-color: #f3eeea ;\n    font-size: large;\n    padding-left: 8px;\n}\n/* Make form container full width on small screens */\n@media (max-width: 768px) {\n  .login-form-container {\n    width: 100% ;\n    padding: 0 15px;\n  }\n\n  .card {\n    width: 100% !important;\n    padding: 10px !important;\n  }\n\n  .form-header {\n    font-size: 16px !important;\n    text-align: center;\n  }\n\n  .footer-container {\n    flex-direction: column !important;\n    text-align: center;\n    padding: 15px 10px !important;\n  }\n\n  .footer-logo-container {\n    justify-content: center !important;\n    margin-top: 10px;\n  }\n\n  .footer-logo-container img {\n    width: 80px;\n  }\n\n  .form-control {\n    font-size: 14px !important;\n  }\n}\n\n/* Better layout for mid-sized devices */\n@media (min-width: 769px) and (max-width: 1024px) {\n  .login-form-container {\n    width: 90% !important;\n  }\n\n  .card {\n    width: 100% !important;\n  }\n\n  .footer-container {\n    padding: 15px 25px !important;\n  }\n}\n\n.pdf-table {\n  width: 100%;\n  border-collapse: separate;\n  border-spacing: 0;\n  table-layout: fixed;\n}\n\n.pdf-table th,\n.pdf-table td {\n  padding: 6px;\n  font-size: 12px;\n  box-shadow:\n    inset -1px 0 0 #000,   /* RIGHT */\n    inset 0 -1px 0 #000;  /* BOTTOM */\n}\n\n/* LEFT border */\n.pdf-table th:first-child,\n.pdf-table td:first-child {\n  box-shadow:\n    inset 1px 0 0 #000,\n    inset -1px 0 0 #000,\n    inset 0 -1px 0 #000;\n}\n\n/* TOP border */\n.pdf-table tr:first-child th {\n  box-shadow:\n    inset 0 1px 0 #000,\n    /* inset -1px 0 0 #000, */\n    inset 0 -1px 0 #000;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
